import api from '@/utils/api';

/**
 * Login user require {email, password}
 * @param {object} loginData - The login data
 * @property {string} loginData.email - The email of the user
 * @property {string} loginData.password - The password of the user
 * @returns {Promise}
 */
const logInApi = (loginData) => api.post('auth/login', loginData);

export default logInApi;
